// extracted by mini-css-extract-plugin
module.exports = {"container":"BasketButton_container__2i_Na","icon":"BasketButton_icon__172_J","countItem":"BasketButton_countItem__3dB96"};